module.exports = __webpack_public_path__ + "static/media/cscc-3.55f2a7cd.jpg";